import { apiUsuarioObtenerGrupos } from "../API";
import { _APP_DATA } from "../AppData";
import { IApiResult, IGroup } from "../models/Entities";
import { RequestData } from "../utils/RequestData";
import { _SvGrupoSetGruposInfoMap } from "./Grupo";


export function _SvUsuarioObtenerGrupos(callback: (groups: IGroup[]) => void) {
    let params = {
        IdUsuario: _APP_DATA.userData.IdUsuario
    };

    new RequestData<IApiResult<IGroup[]>>(apiUsuarioObtenerGrupos)
        .Params(params)
        .Completion((response, error) => {
            let resultData = response?.Datos || [];

            if (error || !response?.Datos) {
                console.log(error, response);
                if (callback) callback(null);
                return;
            }

            _SvGrupoSetGruposInfoMap(resultData)

            if (callback) callback(resultData);
        }).Get();
}
